import { Button, Group, Heading, Text } from '@optiaxiom/react';
import styles from './ErrorFallback.module.css';

/**
 * Shared crash fallback, used by both the React ErrorBoundary (non-router
 * errors) and the router's errorElement (route render / loader errors).
 */
export function ErrorFallback() {
  return (
    <Group
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap="16"
      className={styles.fallback}
    >
      <Heading level="2" fontWeight="700">
        Something went wrong
      </Heading>
      <Text color="fg.secondary">
        The Developer Portal hit an unexpected error. Reloading usually fixes it.
      </Text>
      <Button appearance="primary" onClick={() => window.location.reload()}>
        Reload
      </Button>
    </Group>
  );
}
